// This file is auto-generated by "@aria-ui/cli". Do not edit this file directly.

import { registerAutocompleteItemElement, type AutocompleteItemElement, type AutocompleteItemProps as AutocompleteItemElementProps, type AutocompleteItemEvents } from '@prosekit/web/autocomplete';
import { createElement, forwardRef, useCallback, useRef, type ForwardedRef, type ForwardRefExoticComponent, type HTMLAttributes, type RefAttributes, useLayoutEffect } from 'react';

/** Props for the {@link AutocompleteItem} React component. */
export interface AutocompleteItemProps {
  /**
   * The value of the item, which will be matched against the query.
   *
   * If not provided, the value is the item's text content.
   *
   * @default ""
   */
  value?: AutocompleteItemElementProps['value'];
  /**
   * Whether this option is disabled.
   *
   * @default false
   */
  disabled?: AutocompleteItemElementProps['disabled'];
  /** Emitted when the the item is selected. */
  onSelect?: (event: AutocompleteItemEvents['select']) => void;
}

function AutocompleteItemComponent(props: AutocompleteItemProps, forwardedRef: ForwardedRef<AutocompleteItemElement>) {
  registerAutocompleteItemElement();

  const elementRef = useRef<AutocompleteItemElement>(null);
  const handlersRef = useRef<Array<((event: Event) => void) | undefined>>([]);

  const { disabled: p0, value: p1, onSelect: e0, ...restProps } = props;

  useLayoutEffect(() => {
    const element = elementRef.current as Record<string, unknown> | null;
    if (!element) return;
    Object.assign(element, { disabled: p0, value: p1 });
    handlersRef.current = [e0] as Array<((event: Event) => void) | undefined>;
  });

  useLayoutEffect(() => {
    const element = elementRef.current;
    if (!element) return;
    const ac = new AbortController();
    for (const [index, eventName] of ['select'].entries()) {
      element.addEventListener(
        eventName,
        (event: Event) => {
          handlersRef.current[index]?.(event);
        },
        { signal: ac.signal },
      );
    }
    return () => ac.abort();
  }, []);

  const mergedRef = useCallback(
    (element: AutocompleteItemElement | null) => {
      elementRef.current = element;
      if (typeof forwardedRef === 'function') {
        forwardedRef(element);
      } else if (forwardedRef) {
        forwardedRef.current = element;
      }
    },
    [forwardedRef],
  );

  return createElement('prosekit-autocomplete-item', { ...restProps, ref: mergedRef, suppressHydrationWarning: true });
}

/** A React component that renders an `prosekit-autocomplete-item` custom element. */
export const AutocompleteItem: ForwardRefExoticComponent<AutocompleteItemProps & Omit<HTMLAttributes<AutocompleteItemElement>, 'onSelect'> & RefAttributes<AutocompleteItemElement>> = /* @__PURE__ */ forwardRef(AutocompleteItemComponent);
